import { IRootState } from '@src/store';

export const prepayHotelRatesFilterEnabled = (state: IRootState) => state.organization.org.prepayHotelRatesFilterEnabled;
export const prepayHotelRatesRemovalEnabled = (state: IRootState) => state.organization.org.prepayHotelRatesRemovalEnabled;
